import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import { LoginInfo } from "commonui";
import { store } from "@/commonui/store/index";

@Module({ namespaced: true, name: "oidc", store: store, dynamic: true })
class OidcLogin extends VuexModule {
	public loginInfo?: LoginInfo | null = null;

	@Mutation
	updateLoginInfo(loginInfo?: LoginInfo | null): void {
		this.loginInfo = loginInfo;
	}

	@Action({ commit: "updateLoginInfo" })
	signin(loginInfo?: LoginInfo | null) {
		return loginInfo;
	}

	@Action({ commit: "updateLoginInfo" })
	signout(loginInfo?: LoginInfo | null) {
		//this.context.commit("updateLoginInfo", loginInfo);
		return loginInfo;
	}

	get getLoginInfo() {
		return this.loginInfo;
	}
}
export { OidcLogin };
